import { render, staticRenderFns } from "./ManageChargesDialog.vue?vue&type=template&id=04c74e92"
import script from "./ManageChargesDialog.vue?vue&type=script&lang=js"
export * from "./ManageChargesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports